import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { VehicleAvatar } from '../../../components/VehicleAvatar';
import { formatLicensePlate } from '../../../utils/string';
import { selectWork } from '../../Api/selectors';
import { selectHomeCompany } from '../../Companies/selectors';
import { REQUEST_HOME_COMPANY } from '../../Companies/constants';
import { VehicleStatusLabel } from './VehicleStatusLabel';
import { getVehicleStatusLabel } from '../helpers';

const Container = styled.div`
  font-size: 12px;
  width: ${props => (props.wide ? '100%' : '')};
  .box1 {
    border-bottom: 1px solid #ddd;
    margin-bottom: 8px;
  }
  .vin {
    text-transform: uppercase;
    white-space: nowrap;
  }

  .id {
    color: #aaa;
    font-size: 12px;
  }

  .avatar {
    margin-top: -25px;
    margin-right: -10px;
  }

  .status-block {
    margin-bottom: 20px;
  }

  overflow: hidden;
`;

const STATE = {
  isHome: null,
  vehicleProps: null,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleHeaderV2DesignComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  get plannableStatus() {
    return this.props.vehicle[this.props.task_name];
  }

  get isHomeLocation() {
    return this.props.homeCompany == this.props.vehicle?.location_company_id;
  }

  render() {
    const vehicle = this.props.vehicle;

    if (!vehicle) return null;
    return (
      <Container  wide={this.props.wide} onClick={this.props.onClick}>
        <VBox className={this.props.className}>
          <HBox>
            <div>
              <strong>
                {vehicle.brand_name}&nbsp;{vehicle.model_name}
              </strong>
            </div>
          </HBox>

          <HBox vCenter className="box1">
            <div>
              {formatLicensePlate(vehicle.regplate)}
              <br />
              <span className="vin">{vehicle.vin}</span>
              <br />
              <span className="id">{vehicle.id}</span>
              <br />
              <HBox className="status-block">
                {this.props.statusLabel || (
                  <VehicleStatusLabel status={vehicle.status}>
                    {getVehicleStatusLabel(vehicle.status, this.lbl)}
                  </VehicleStatusLabel>
                )}
              </HBox>
            </div>

            <VehicleAvatar vehicle={vehicle} onClick={this.tofn(`/vehicles/${vehicle.id}`)} />
          </HBox>
        </VBox>
      </Container>
    );
  }
}

VehicleHeaderV2DesignComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_HOME_COMPANY),
    homeCompany: selectHomeCompany(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleHeaderV2Design = compose(withConnect, withRouter)(VehicleHeaderV2DesignComp);
